import { Component, OnInit } from '@angular/core';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { Logger, CryptoUtils } from 'msal';
import { BaseAutorizeComponent } from './shared/base-authorize.component';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent extends BaseAutorizeComponent implements OnInit {
  title = 'Smart Workplace Management';

  constructor(broadcastService: BroadcastService, authService: MsalService) { 
    super(broadcastService, authService)
  }

  onInitChild(){
    
  }


}
